export enum ColumnSortDirection {
  Ascending = 'asc',
  Descending = 'desc',
}